import { render, staticRenderFns } from "./cModalHistoryCredits.vue?vue&type=template&id=4f3ea067"
import script from "./cModalHistoryCredits.vue?vue&type=script&lang=js"
export * from "./cModalHistoryCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports